import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Also send token via header as a fallback (cookies may be blocked cross-site)
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

/**
 * Iter 54 — fire-and-forget analytics for Undo-toast performance.
 * Silently swallows failures so a flaky analytics endpoint never breaks
 * the toast flow. Called from every "shown" fire site and every "clicked"
 * handler. Expire rate is inferred server-side as (shown - clicked).
 */
export function logUndoEvent(action, kind) {
  try {
    api.post("/analytics/undo-event", { action, kind }).catch(() => {});
  } catch {}
}

export const fmtMoney = (n, opts = {}) => {
  if (n == null || Number.isNaN(n)) return "—";
  const { showSign = false, decimals = 2 } = opts;
  const abs = Math.abs(n);
  const sign = n > 0 ? "+" : n < 0 ? "-" : "";
  const val = abs.toLocaleString("en-US", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  return (showSign ? sign : n < 0 ? "-" : "") + "$" + val;
};

export const fmtPct = (n) => {
  if (n == null || Number.isNaN(n)) return "—";
  const sign = n > 0 ? "+" : "";
  return `${sign}${n.toFixed(2)}%`;
};

export const fmtNum = (n, decimals = 2) => {
  if (n == null || Number.isNaN(n)) return "—";
  return n.toLocaleString("en-US", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};
